import { User, UserRole } from '@/types'
import { canAccessFacturation } from '@/utils/role-access'

export interface NavItemConfig {
  path: string
  label: string
  /** User role must be one of these (empty = any authenticated user). */
  roles?: UserRole[]
  /** Optional fine-grained access check (e.g. exclude attached resellers). */
  accessCheck?: (user: User | null) => boolean
}

export const NAV_ITEMS: NavItemConfig[] = [
  {
    path: '/',
    label: 'Tableau de bord',
    roles: [
      UserRole.ADMIN,
      UserRole.VIEWER,
      UserRole.RESELLER,
      UserRole.WHOLESALER,
    ],
  },
  {
    path: '/users',
    label: 'Utilisateurs',
    roles: [UserRole.ADMIN],
  },
  {
    path: '/wholesalers',
    label: 'Grossistes',
    roles: [UserRole.ADMIN],
  },
  {
    path: '/resellers',
    label: 'Revendeurs',
    roles: [UserRole.ADMIN],
  },
  {
    path: '/attached-resellers',
    label: 'Revendeurs rattachés',
    roles: [UserRole.ADMIN, UserRole.WHOLESALER],
  },
  {
    path: '/clients',
    label: 'Clients',
    roles: [
      UserRole.ADMIN,
      UserRole.VIEWER,
      UserRole.RESELLER,
    ],
  },
  {
    path: '/attached-clients',
    label: 'Clients rattachés',
    roles: [UserRole.ADMIN],
  },
  {
    path: '/facturation',
    label: 'Facturation',
    roles: [
      UserRole.ADMIN,
      UserRole.VIEWER,
      UserRole.RESELLER,
      UserRole.WHOLESALER,
    ],
    accessCheck: user => canAccessFacturation(user),
  },
  {
    path: '/logs',
    label: "Journaux d'activité",
    roles: [UserRole.ADMIN, UserRole.VIEWER],
  },
  {
    path: '/settings',
    label: 'Paramètres',
    roles: [UserRole.ADMIN, UserRole.VIEWER],
  },
]
